import script from "./ShoppingPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShoppingPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ShoppingPreview.vue?vue&type=style&index=0&id=1b6f3556&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6f3556"]])

export default __exports__